:host {
    display: flex;
    flex-direction: column;

    #mapElement {
        background-color: var(--gray-100);
        //height:400px;
        flex-grow: 1;
    }

    // Info Window
    .gm-style-iw {
        &.gm-style-iw-c {
            font-family: var(--font-sans-serif);
            padding: 1rem !important;
            border-radius: 3px !important;
        }
        .gm-style-iw-d {
            padding: 0 !important;
            overflow: auto !important;
            & + button {
                top: -3px !important;
                right: -3px !important;
            }
        }
    }
    .location-popup {
        display: flex;
        flex-wrap: nowrap;
        a {
            color: var(--primary);
        }
        &-image {
            flex-grow: 0;
            flex-shrink: 0;
            width: 90px;
            height: 90px;
            overflow: hidden;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
        &-details {
            font-size: 12px;
            padding: 0 1rem;
            h3 {
                font-size: 16px;
                margin: 0;
            }
            p {
                margin-top: 10px;
                margin-bottom: 0rem;
            }
        }
    }
}
